import axios from "axios";
import React, { useContext } from "react";
import { VARIABLES } from "../../Constant";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";
import swal from "sweetalert";
import { useGlobalContext } from "../Context";
import { StateContext } from "../../Context/StateContext";

const PlantZoneSchedularTable = (props) => {
  const LoggedId = secureLocalStorage.getItem("loggedId");
  const privileges = secureLocalStorage.getItem("privileges");
  const { mqttClient } = useGlobalContext();
  const { setLastScheduleIndex, isBulkSchedulerUpdating } =
    useContext(StateContext);

  // const updateHandler = () => {
  //   console.log(props.schedularZone)
  //   const url = VARIABLES.url +'/api/mqtt-json?node_id=' + props.schedularZone.node_id
  //   console.log(url)
  //   var config = {
  //     method: 'get',
  //     url: url,
  //     headers: { }
  //   };

  //   axios(config)
  //   .then(function (response) {
  //     console.log(JSON.stringify(response.data));
  //     swal({
  //       icon : "success",
  //       title: "Scheduler Updated Successfully",
  //       showConfirmButton: false,
  //       timer: 2000
  //     })
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //     swal({
  //       icon: 'error',
  //       title: 'Failed to update Scheduler',
  //       showConfirmButton: false,
  //       timer: 2000
  //     })
  //   });

  // }

  const deleteProject = (id) => {
    const deleteDetails = {
      action: "delete",
      id: id,
      node_id: props.schedularZone.node_id,
    };
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Deleted Successfully!",
      showConfirmButton: true,
    }).then(() => {
      props.setSchedularData(
        props.schedulerData.filter((user) => {
          return user.id !== id;
        }),
      );
      props.setNodeSchedulerData((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, ...deleteDetails } : item,
        ),
      );
    });
    // const url = VARIABLES.url + `/api/scheduler-details/${id}`;
    // console.log(url);
    // var config = {
    //   method: "delete",
    //   url: url,
    //   headers: {},
    // };
    // console.log("deleted project reached");
    // axios(config)
    //   .then((response) => {
    //     Swal.fire({
    //       title: "Deleted Successfully!",
    //       icon: "success",
    //       showConfirmButton: true,
    //     });
    //     console.log(JSON.stringify(response.data));
    //     // window.location.reload();
    //     props.setSchedularData(
    //       props.schedulerData.filter((user) => {
    //         return user.id !== id;
    //       })
    //     );
    //   })
    //   .catch((error) => {
    //     Swal.fire({
    //       title: " Not Deleted Successfully!",
    //       icon: "warning",
    //       showConfirmButton: true,
    //     });
    //     console.log(error);
    //   });
  };

  const deleteProjectAlert = (id) => {
    Swal.fire({
      title: "Are you sure? You will not be able to recover this project!",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
      denyButtonText: `No, cancel!`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deleteProject(id);
      }
    });
  };

  // Helper function to check if day adjustment is needed
  const checkDayAdjustment = (timeStr, offset) => {
    const timeParts = timeStr.split(":");
    const hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);
    // Seconds don't affect day boundary calculation

    const isNegative = offset.startsWith("-");
    const cleanOffset = offset.replace(/[+-]/, "");
    const [offsetHours, offsetMinutes = 0] = cleanOffset.split(":").map(Number);

    let totalMinutes = hours * 60 + minutes;

    if (isNegative) {
      totalMinutes += offsetHours * 60 + offsetMinutes;
    } else {
      totalMinutes -= offsetHours * 60 + offsetMinutes;
    }

    if (totalMinutes < 0) return -1; // Previous day
    if (totalMinutes >= 24 * 60) return 1; // Next day
    return 0; // Same day
  };

  // Helper function to adjust the scheduler day
  const adjustSchedulerDay = (dayStr, adjustment) => {
    const dayMap = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };
    const reverseDayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Handle single day
    if (dayMap.hasOwnProperty(dayStr)) {
      let dayIndex = dayMap[dayStr];
      dayIndex = (dayIndex + adjustment + 7) % 7;
      return reverseDayMap[dayIndex];
    }

    // Handle multiple days if stored as array string
    // You may need to adjust this based on your actual data format
    return dayStr;
  };

  // Convert API Structure to HH:MM:SS weekly DAY format
  //  const convertToStructuredScheduleInput = (schedulerData) => {
  const convertToStructuredScheduleInput = (
    schedulerData,
    timeOffset = "+05:30",
  ) => {
    const formattedSchedules = [];

    schedulerData
      .filter((item) => item.action !== "delete")
      .forEach((item) => {
        const time = item.scheduler_time;
        // Parse and adjust time for timezone offset
        const adjustedTime = adjustTimeForOffset(time, timeOffset);
        const timeWithSeconds = adjustedTime; // HH:MM:SS
        //const timeWithSeconds = `${time}:00`; // HH:MM:SS, e.g., "16:12:00"

        // Extract pin_number and status
        const pinNumber = item.entity?.pin_number;
        // Ensure is_on is a number (1 or 0) for your later cron function
        const isOnStatus = item.is_on === true || item.is_on === 1 ? 1 : 0;

        const schedulerID = item.id;

        // The scheduler_day is a string that looks like an array, e.g., "['Mon', 'Fri']"
        let daysString = item.scheduler_day;

        // 1. Remove brackets and quotes to get a clean comma-separated list of days.
        // daysString = daysString.replace(/\[|\]|'|"/g, "");
        console.log(daysString);

        // 2. Split the string into an array of individual days.
        // const daysArray = daysString
        //   .split(",")
        //   .map((day) => day.trim())
        //   .filter((day) => day.length > 0);

        // 3. Create a separate structured object for each day.
        // daysArray.forEach((day) => {
        // Check if day adjustment is needed due to timezone conversion
        const dayAdjustment = checkDayAdjustment(time, timeOffset);
        const adjustedDay =
          dayAdjustment !== 0
            ? adjustSchedulerDay(item.scheduler_day, dayAdjustment)
            : item.scheduler_day;

        formattedSchedules.push({
          formatted_input: `${timeWithSeconds} weekly ${adjustedDay}`,
          is_on: isOnStatus,
          pin_number: pinNumber,
          scheduler_id: schedulerID,
          node_id: item.entity?.node_id,
        });
      });
    // });

    return formattedSchedules;
  };

  // Helper function to adjust time based on timezone offset
  const adjustTimeForOffset = (timeStr, offset) => {
    // Parse the time string (can be HH:MM or HH:MM:SS format)
    const timeParts = timeStr.split(":");
    const hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);
    const seconds = timeParts[2] ? parseInt(timeParts[2]) : 0; // Handle seconds if present

    // Parse the offset (e.g., "+05:30" or "-08:00")
    const isNegative = offset.startsWith("-");
    const cleanOffset = offset.replace(/[+-]/, "");
    const [offsetHours, offsetMinutes = 0] = cleanOffset.split(":").map(Number);

    // Convert current time to minutes (keeping seconds separate)
    let totalMinutes = hours * 60 + minutes;

    // Subtract offset to get GMT (if offset is positive, we subtract; if negative, we add)
    if (isNegative) {
      totalMinutes += offsetHours * 60 + offsetMinutes;
    } else {
      totalMinutes -= offsetHours * 60 + offsetMinutes;
    }

    // Handle day wraparound
    if (totalMinutes < 0) {
      totalMinutes += 24 * 60; // Add a day's worth of minutes
    } else if (totalMinutes >= 24 * 60) {
      totalMinutes -= 24 * 60; // Subtract a day's worth of minutes
    }

    // Convert back to hours and minutes
    const adjustedHours = Math.floor(totalMinutes / 60);
    const adjustedMinutes = totalMinutes % 60;

    // Format as HH:MM:SS
    return `${String(adjustedHours).padStart(2, "0")}:${String(
      adjustedMinutes,
    ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  // Cron Conversion Logic Starts Here
  class UserInputToCron {
    constructor() {
      // Weekday mappings
      this.WEEKDAYS = {
        sunday: "0",
        sun: "0",
        monday: "1",
        mon: "1",
        tuesday: "2",
        tue: "2",
        tues: "2",
        wednesday: "3",
        wed: "3",
        thursday: "4",
        thu: "4",
        thur: "4",
        thurs: "4",
        friday: "5",
        fri: "5",
        saturday: "6",
        sat: "6",
      };

      // Month mappings
      this.MONTHS = {
        january: "1",
        jan: "1",
        february: "2",
        feb: "2",
        march: "3",
        mar: "3",
        april: "4",
        apr: "4",
        may: "5",
        june: "6",
        jun: "6",
        july: "7",
        jul: "7",
        august: "8",
        aug: "8",
        september: "9",
        sep: "9",
        sept: "9",
        october: "10",
        oct: "10",
        november: "11",
        nov: "11",
        december: "12",
        dec: "12",
      };

      // Frequency mappings
      this.FREQUENCIES = {
        daily: "daily",
        everyday: "daily",
        "every day": "daily",
        weekly: "weekly",
        "every week": "weekly",
        monthly: "monthly",
        "every month": "monthly",
        yearly: "yearly",
        annually: "yearly",
        "every year": "yearly",
      };
    }

    /**
     * Parse time string in various formats
     * @param {string} timeStr - Time string to parse
     * @returns {Object} - {hour, minute, second}
     */
    parseTime(timeStr) {
      timeStr = timeStr.trim().toLowerCase();
      let hour = 0,
        minute = 0,
        second = 0;

      // Remove 'at' if present
      timeStr = timeStr.replace(/at\s+/g, "");

      // Check for AM/PM
      const isPM = /pm|p\.m\./.test(timeStr);
      const isAM = /am|a\.m\./.test(timeStr);

      // Clean up the time string
      timeStr = timeStr.replace(/[ap]\.?m\.?/g, "").trim();

      // Parse different formats
      const timeParts = timeStr.split(":");

      if (timeParts.length === 3) {
        // Format: HH:MM:SS
        hour = parseInt(timeParts[0]);
        minute = parseInt(timeParts[1]);
        second = parseInt(timeParts[2]);
      } else if (timeParts.length === 2) {
        // Format: HH:MM
        hour = parseInt(timeParts[0]);
        minute = parseInt(timeParts[1]);
      } else if (/^\d+$/.test(timeStr)) {
        // Format: just hour
        hour = parseInt(timeStr);
      } else {
        // Try to extract numbers
        const numbers = timeStr.match(/\d+/g);
        if (numbers) {
          hour = parseInt(numbers[0]);
          if (numbers[1]) minute = parseInt(numbers[1]);
          if (numbers[2]) second = parseInt(numbers[2]);
        }
      }

      // Convert to 24-hour format
      if (isPM && hour !== 12) {
        hour += 12;
      } else if (isAM && hour === 12) {
        hour = 0;
      }

      return { hour, minute, second };
    }

    /**
     * Extract weekdays from text
     * @param {string} text - Input text
     * @returns {Array} - Array of weekday numbers as strings
     */
    parseWeekdays(text) {
      text = text.toLowerCase();
      const weekdays = [];

      // Find all matching weekdays
      for (const [dayName, dayNum] of Object.entries(this.WEEKDAYS)) {
        if (text.includes(dayName)) {
          weekdays.push(dayNum);
        }
      }

      // Handle ranges like "monday to friday" or "mon-fri"
      if (
        (text.includes(" to ") || text.includes("-")) &&
        weekdays.length >= 2
      ) {
        // Sort and create range
        const sorted = weekdays.map(Number).sort((a, b) => a - b);
        const start = sorted[0];
        const end = sorted[sorted.length - 1];
        const range = [];
        for (let i = start; i <= end; i++) {
          range.push(String(i));
        }
        return range;
      }

      // Remove duplicates and sort
      return [...new Set(weekdays)].sort((a, b) => Number(a) - Number(b));
    }

    /**
     * Extract months from text
     * @param {string} text - Input text
     * @returns {Array} - Array of month numbers as strings
     */
    parseMonths(text) {
      text = text.toLowerCase();
      const months = [];

      for (const [monthName, monthNum] of Object.entries(this.MONTHS)) {
        if (text.includes(monthName)) {
          months.push(monthNum);
        }
      }

      // Remove duplicates and sort
      return [...new Set(months)].sort((a, b) => Number(a) - Number(b));
    }

    /**
     * Extract day of month from text
     * @param {string} text - Input text
     * @returns {Array} - Array of day numbers as strings
     */
    parseDayOfMonth(text) {
      text = text.toLowerCase();
      const days = [];

      // Look for patterns like "1st", "2nd", "15th", etc.
      const ordinalPattern = /(\d{1,2})(?:st|nd|rd|th)/g;
      let match;
      while ((match = ordinalPattern.exec(text)) !== null) {
        days.push(match[1]);
      }

      if (days.length > 0) {
        return days;
      }

      // Look for just numbers that might be dates
      if (text.includes("day")) {
        const numberPattern = /\b([1-9]|[12][0-9]|3[01])\b/g;
        while ((match = numberPattern.exec(text)) !== null) {
          days.push(match[1]);
        }
      }

      return days;
    }

    /**
     * Determine the frequency pattern
     * @param {string} text - Input text
     * @returns {string} - Frequency type
     */
    parseFrequency(text) {
      text = text.toLowerCase();

      // Check predefined frequencies
      for (const [freqText, freqType] of Object.entries(this.FREQUENCIES)) {
        if (text.includes(freqText)) {
          return freqType;
        }
      }

      // Check for specific patterns
      if (text.includes("every")) {
        // Check for weekdays
        for (const dayName of Object.keys(this.WEEKDAYS)) {
          if (text.includes(dayName)) {
            return "weekly";
          }
        }

        // Check for months
        for (const monthName of Object.keys(this.MONTHS)) {
          if (text.includes(monthName)) {
            return "yearly";
          }
        }

        // Check for day of month
        if (/\d{1,2}(?:st|nd|rd|th)/.test(text)) {
          return "monthly";
        }

        // Check for time units
        if (text.includes("second")) {
          return "every_n_seconds";
        }
        if (text.includes("minute")) {
          return "every_n_minutes";
        }
        if (text.includes("hour")) {
          return "hourly";
        }
      }

      // Check for weekday-specific patterns
      if (text.includes("weekday") || text.includes("business day")) {
        return "weekdays";
      }

      if (text.includes("weekend")) {
        return "weekends";
      }

      return "once";
    }

    /**
     * Convert user input to 7-field cron expression
     * @param {string} userInput - Natural language input
     * @returns {string} - 7-field cron expression
     */
    convertToCron(userInput) {
      // Initialize cron fields
      let second = "*";
      let minute = "*";
      let hour = "*";
      let day = "*";
      let month = "*";
      let weekday = "*";

      const lowerInput = userInput.toLowerCase();

      // Parse time if present
      const timePattern = /(\d{1,2}(?::\d{2}){0,2}\s*(?:[ap]\.?m\.?)?)/;
      const timeMatch = lowerInput.match(timePattern);

      if (timeMatch) {
        const timeStr = timeMatch[1];
        const { hour: h, minute: m, second: s } = this.parseTime(timeStr);
        hour = String(h);
        minute = String(m);
        second = String(s);
      }

      // Parse frequency
      const frequency = this.parseFrequency(userInput);

      // Parse specific days/months
      const weekdays = this.parseWeekdays(userInput);
      const months = this.parseMonths(userInput);
      const days = this.parseDayOfMonth(userInput);

      // Apply frequency rules
      if (frequency === "daily") {
        // Keep day, month, weekday as * (already set)
      } else if (frequency === "weekly" && weekdays.length > 0) {
        weekday = weekdays.join(",");
      } else if (frequency === "weekdays") {
        weekday = "1-5"; // Monday to Friday
      } else if (frequency === "weekends") {
        weekday = "0,6"; // Saturday and Sunday
      } else if (frequency === "monthly" && days.length > 0) {
        day = days.join(",");
      } else if (frequency === "yearly") {
        if (months.length > 0) {
          month = months.join(",");
        }
        if (days.length > 0) {
          day = days.join(",");
        }
      } else if (
        frequency === "every_n_seconds" ||
        frequency === "every_n_minutes"
      ) {
        // Extract the number
        const numbers = userInput.match(/\d+/g);
        if (numbers) {
          const n = numbers[0];
          if (frequency === "every_n_seconds") {
            second = `*/${n}`;
            minute = "*";
            hour = "*";
          } else if (frequency === "every_n_minutes") {
            minute = `*/${n}`;
            hour = "*";
            if (second === "*") {
              second = "0"; // Default to 0 seconds
            }
          }
        }
      } else if (frequency === "hourly") {
        // Every hour
        if (minute === "*") minute = "0";
        if (second === "*") second = "0";
        hour = "*";
      } else if (frequency === "once") {
        // Handle one-time runs (specific date/time)
        if (
          weekdays.length > 0 &&
          !userInput.includes("every") &&
          !userInput.includes("each")
        ) {
          weekday = weekdays.join(",");
        }
        if (months.length > 0) {
          month = months.join(",");
        }
        if (days.length > 0) {
          day = days.join(",");
        }
      }

      // Special cases for common patterns
      if (lowerInput.includes("midnight")) {
        hour = "0";
        minute = "0";
        second = "0";
      } else if (lowerInput.includes("noon")) {
        hour = "12";
        minute = "0";
        second = "0";
      }

      // Build the cron expression
      return `${second} ${minute} ${hour} ${day} ${month} ${weekday}`;
    }

    /**
     * Validate the generated cron expression
     * @param {string} cronExpr - Cron expression to validate
     * @returns {boolean} - True if valid
     */
    validateCron(cronExpr) {
      const parts = cronExpr.split(" ");
      if (parts.length !== 6) {
        return false;
      }

      // Basic validation for each field
      const ranges = [
        { min: 0, max: 59 }, // seconds
        { min: 0, max: 59 }, // minutes
        { min: 0, max: 23 }, // hours
        { min: 1, max: 31 }, // days
        { min: 1, max: 12 }, // months
        { min: 0, max: 6 }, // weekdays
      ];

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const { min, max } = ranges[i];

        if (part === "*") continue;

        // Check for step values
        if (part.includes("/")) continue;

        // Check for ranges
        if (part.includes("-")) {
          const [start, end] = part.split("-").map(Number);
          if (
            isNaN(start) ||
            isNaN(end) ||
            start < min ||
            start > max ||
            end < min ||
            end > max
          ) {
            return false;
          }
        }
        // Check for comma-separated values
        else if (part.includes(",")) {
          const values = part.split(",");
          for (const val of values) {
            const num = Number(val);
            if (isNaN(num) || num < min || num > max) {
              return false;
            }
          }
        }
        // Single value
        else {
          const num = Number(part);
          if (isNaN(num) || num < min || num > max) {
            return false;
          }
        }
      }

      return true;
    }
  }

  function convertUserInputToCron(userInput) {
    const converter = new UserInputToCron();

    // Generate cron expression
    const cronExpression = converter.convertToCron(userInput);

    // Validate
    const isValid = converter.validateCron(cronExpression);

    // Create human-readable description
    const parts = cronExpression.split(" ");
    const descriptionParts = [];

    if (parts[0] !== "*") {
      if (parts[0].includes("/")) {
        descriptionParts.push(`every ${parts[0].split("/")[1]} seconds`);
      } else {
        descriptionParts.push(`at ${parts[0]} seconds`);
      }
    }

    if (parts[1] !== "*" && !parts[1].includes("/")) {
      descriptionParts.push(`at minute ${parts[1]}`);
    } else if (parts[1].includes("/")) {
      descriptionParts.push(`every ${parts[1].split("/")[1]} minutes`);
    }

    if (parts[2] !== "*") {
      const hour = parseInt(parts[2]);
      const amPm = hour < 12 ? "AM" : "PM";
      const hour12 = hour % 12 || 12;
      descriptionParts.push(`at ${hour12}${amPm}`);
    }

    if (parts[3] !== "*") {
      descriptionParts.push(`on day ${parts[3]}`);
    }

    if (parts[4] !== "*") {
      descriptionParts.push(`in month ${parts[4]}`);
    }

    if (parts[5] !== "*") {
      const weekdayNames = {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
      };
      const dayNums = parts[5].split(",");
      const dayNames = dayNums.map((d) => weekdayNames[d] || d);
      descriptionParts.push(`on ${dayNames.join(", ")}`);
    }

    const description =
      descriptionParts.length > 0
        ? descriptionParts.join(" ")
        : "Invalid schedule";

    return {
      cron_expression: cronExpression,
      description: description,
      is_valid: isValid,
      input: userInput,
    };
  }

  // Example usage
  if (typeof module !== "undefined" && module.exports) {
    module.exports = { UserInputToCron, convertUserInputToCron };
  }
  // Cron Conversion Logic Ends Here

  // To turn on the node flag
  // onSubmit handler to edit the "Zone"
  const nodeFlgTurnOn = () => {
    var node_flag = JSON.stringify({
      name: props.schedularZone.node_id,
      is_in_progress: 1,
      updated_by_id: LoggedId,
    });

    var config = {
      method: "patch",
      url:
        VARIABLES.url + `/api/category-master-inprogress?action=is_in_progress`,

      headers: {
        "Content-Type": "application/json",
      },
      data: node_flag,
    };

    axios(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Pin and Entity status formatting logic starts here
  function createPinScheduleList(inputJson) {
    if (!Array.isArray(inputJson) || inputJson.length === 0) {
      const emptyMsg = "5#[]^";

      console.log("No scheduler data. Publishing empty schedule:", emptyMsg);

      if (mqttClient && mqttClient.isConnected()) {
        mqttClient.publish(
          `${VARIABLES.subdomain}/${VARIABLES.project_id}/${props.schedularZone.node_id}/reading/values/timer_cmd`,
          emptyMsg,
          1,
          false,
          (error) => {
            if (error) {
              console.error("Error publishing empty schedule:", error);
            } else {
              console.log(`Published: ${emptyMsg}`);
            }
          },
        );
      } else {
        console.log("Connection lost");
      }

      return; // ⛔ STOP function execution here
    }
    nodeFlgTurnOn();
    const cronInputs = convertToStructuredScheduleInput(inputJson);
    console.log(cronInputs);
    const finalScheduleList = [];

    cronInputs.forEach((item) => {
      // 1. Get the Cron output using the provided function
      const cronResult = convertUserInputToCron(item.formatted_input);
      const cronOutput = cronResult.cron_expression; // e.g., "0 12 16 * * 1"

      // 2. Map boolean status to 1 or 0
      const entityStatus = item.is_on == 1 ? "0" : "1";

      // 3. Get the pin number
      const pinNumber = item.pin_number;

      // 4. Get Scheduler ID
      const schedulerID = item.scheduler_id;

      // 5. CONSTRUCT THE NEW DICTIONARY FORMAT
      const scheduleObject = {
        id: schedulerID,
        cron: cronOutput,
        pattern: `${entityStatus}?${pinNumber}`, // "1?D4" or "0?D4"
      };

      finalScheduleList.push(scheduleObject);
    });

    // 6. Final Formatting Step:
    // Map the array of objects to strings, then join with 5#[...]
    // const finalFormattedItems = finalScheduleList.map((item) =>
    //   JSON.stringify(item)
    // );

    // console.log(finalFormattedItems);

    finalScheduleList.forEach((item, index) => {
      console.log(item);
      // Decide prefix based on index
      // const prefix = index === 0 ? "5#" : "1#";

      let msg;

      if (index === 0) {
        // First entry → use full JSON object with 5#
        msg = `5#[{"id":"T0", "cron":"${item.cron}", "pattern": "${item.pattern}"}]^`;
      } else {
        // Next entries → 1#0|cron|pattern^
        msg = `1#0|${item.cron}|${item.pattern}^`;
      }

      console.log("Publishing:", msg);

      if (index === finalScheduleList.length - 1) {
        setLastScheduleIndex(msg); // <-- Sets the last message in React state
      }

      console.log(
        `${VARIABLES.subdomain}/${VARIABLES.project_id}/${props.schedularZone.node_id}/reading/values/timer_cmd`,
      );

      if (mqttClient && mqttClient.isConnected()) {
        mqttClient.publish(
          `${VARIABLES.subdomain}/${VARIABLES.project_id}/${props.schedularZone.node_id}/reading/values/timer_cmd`,
          msg,
          1,
          false,
          (error) => {
            if (error) {
              console.error("Error publishing:", error);
            } else {
              console.log(`Published: ${msg}`);
            }
          },
        );
      } else {
        console.log("Connection lost");
      }
    });

    secureLocalStorage.setItem("scheduler_id", props.schedularZone.id);
    console.log(props.schedularZone.id);
    secureLocalStorage.setItem(
      "scheduler_node_id",
      props.schedularZone.node_id,
    );
    console.log(props.schedularZone.node_id);

    // 7. Join the items and prefix with "5#["
    // Using the clean stringified objects for the join:
    // const finalOutput = `5#[${finalFormattedItems.join(", ")}]`;
    // console.log(finalOutput);

    // if (mqttClient && mqttClient.isConnected()) {
    //   console.log("Connect---------");
    //   mqttClient.publish(`${VARIABLES.subdomain}/${VARIABLES.project_id}/${props.schedularZone.node_id}/${props.schedularZone.pin_number}/values/timer_cmd`, finalOutput, 0, false, (error) => {
    //     console.log("Publish Connect---------", error);
    //     if (error) {
    //       console.error("Error publishing to topic:", error);
    //     } else {
    //       console.log(`Published to test/topic/dummy: ${finalOutput}`);
    //     }
    //   });
    // } else {
    //   console.log("Connection lost");
    // }

    // Return the single final string
    // return finalOutput;
  }

  return (
    <>
      <div className="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card card-full">
            <div class="card-inner">
              <div class="card-title-group">
                <div class="card-title">
                  <h6 class="title">Zone Scheduler</h6>
                </div>
                {privileges.includes("update_zone_scheduler") && (
                  <div>
                    <button
                      className="btn btn-primary btn-dim"
                      onClick={() =>
                        createPinScheduleList(props.nodeSchedulerData)
                      }
                    >
                      {/* Update */}
                      {isBulkSchedulerUpdating
                        ? "Updating..."
                        : "Update Scheduler"}
                    </button>
                  </div>
                )}
              </div>
            </div>
            {props.isLoading ? (
              <div className="card-inner"> Loading...</div>
            ) : (
              <div className="table-responsive">
                <table className="table">
                  <div class="nk-tb-list mt-2">
                    <div class="nk-tb-item nk-tb-head">
                      <div class="nk-tb-col">
                        <span>Entity Name</span>
                      </div>
                      <div class="nk-tb-col">
                        <span>Scheduler Days</span>
                      </div>
                      <div class="nk-tb-col">
                        <span>Scheduler Time</span>
                      </div>
                      <div class="nk-tb-col">
                        <span>Scheduler ON/OFF status</span>
                      </div>
                      <div class="nk-tb-col">
                        <span>Edit</span>
                      </div>
                      <div class="nk-tb-col">
                        <span>Delete</span>
                      </div>
                    </div>
                    {props.schedulerData.length === 0 && (
                      <tbody>
                        <tr>
                          <td></td>
                          <td>No data found</td>
                          <td></td>
                        </tr>
                      </tbody>
                    )}
                    {props.schedulerData.length > 0 && (
                      <tbody>
                        {props.schedulerData.map((set, index) => {
                          const schedule_day = set.scheduler_day.slice(1, -1);
                          // console.log(schedule_day)
                          const schedule_Week = schedule_day.split(", ");
                          // console.log(schedule_Week)
                          var arr = [];
                          for (var i = 0; i <= schedule_Week.length - 1; i++) {
                            const schedule = schedule_Week[i].substring(
                              1,
                              schedule_Week[i].length - 1,
                            );
                            // console.log(schedule)
                            arr.push(schedule);
                            // console.log(arr)
                          }
                          return (
                            <div class="nk-tb-item">
                              <div class="nk-tb-col">
                                <span class="tb-lead">
                                  <a href="#">
                                    {set?.entity
                                      ? set?.entity?.name
                                      : props.schedularZone.name}
                                  </a>
                                </span>
                              </div>
                              <div class="nk-tb-col">
                                <div class="user-card">
                                  {/* <div class="user-avatar sm bg-purple-dim">
                      <span>AB</span>
                    </div> */}
                                  <div class="user-name">
                                    <span class="tb-lead">
                                      {arr.length - 1 > 0
                                        ? arr.join(", ")
                                        : arr}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="nk-tb-col">
                                <span class="tb-sub">{set.scheduler_time}</span>
                              </div>
                              <div class="nk-tb-col">
                                {set.is_on === true ? (
                                  <span class="badge badge-dot badge-dot-xs bg-success">
                                    ON
                                  </span>
                                ) : (
                                  <span class="badge badge-dot badge-dot-xs bg-danger">
                                    OFF
                                  </span>
                                )}
                              </div>
                              {privileges.includes("edit_zone_scheduler") && (
                                <div class="nk-tb-col">
                                  <button
                                    className="ni ni-edit btn btn-outline-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#editSchedule"
                                    onClick={() => props.editSchedule(set.id)}
                                  ></button>
                                </div>
                              )}

                              {privileges.includes("delete_zone_scheduler") && (
                                <div class="nk-tb-col">
                                  <button
                                    className="ni ni-trash btn btn-outline-primary"
                                    onClick={() => deleteProjectAlert(set.id)}
                                  ></button>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </tbody>
                    )}
                  </div>
                </table>
              </div>
            )}
          </div>
          {/* <!-- .card --> */}
        </div>
      </div>
    </>
  );
};

export default PlantZoneSchedularTable;
